import { api } from './auth.service';

const planejamentoAnalistaService = {

  // Lista analistas de um negócio (cada um com seus itens atribuídos)
  listar: async (negocioId) => {
    const res = await api.get(`/planejamento-analistas/negocio/${negocioId}`);
    return res.data;
  },

  // Adiciona um novo analista ao negócio
  // dados = { colaborador_id, item_ids: [int], usuario_id }
  criar: async (negocioId, dados) => {
    const res = await api.post(`/planejamento-analistas/negocio/${negocioId}`, dados);
    return res.data;
  },

  // Atualiza a lista de itens atribuídos a um analista
  atualizarItens: async (analistaId, itemIds) => {
    const res = await api.put(`/planejamento-analistas/${analistaId}/itens`, {
      item_ids: itemIds,
    });
    return res.data;
  },

  // Remove um analista
  excluir: async (analistaId) => {
    const res = await api.delete(`/planejamento-analistas/${analistaId}`);
    return res.data;
  },
};

export default planejamentoAnalistaService;
